module.exports = __webpack_public_path__ + "click-on-call-red.png?a8d168550f045509f1597d2b21f53913";


//////////////////
// WEBPACK FOOTER
// ./src/assets/click-on-call-red.png
// module id = 20
// module chunks = 0